import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { IS_PRODUCTION } from '@rma/public/generic/util/environment';
import { RmaLayoutComponent } from '@rma/public/site/public/orc-layout';
import { RecaptchaComponent } from 'ng-recaptcha';
import { config } from './app/app.config.browser';

if (IS_PRODUCTION) {
  enableProdMode();
}

// Yielding the current task gives the browser a chance to paint the SSR markup before hydration
// walks the tree. rAF runs before the frame's own paint, so this defers rather than guarantees one;
// whether a second frame is worth the delay to hydration is a question for the Lighthouse numbers.
requestAnimationFrame(() => bootstrapApplication(RmaLayoutComponent, config).catch((err) => console.error(err)));

RecaptchaComponent.prototype.ngOnDestroy = function () {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
};
